const state = {
    workflowApprovalData: {},
};

export default state;
